var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Empty State / Relax-New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 55,
    cy: 115,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-2",
    cx: 98,
    cy: 105,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-3",
    cx: 146,
    cy: 106,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-4",
    cx: 161,
    cy: 115,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-5",
    cx: 187,
    cy: 119,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-6",
    cx: 197,
    cy: 90,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-7",
    cx: 40,
    cy: 90,
    rx: 40,
    ry: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Empty-State-/-Relax-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Tree_swing_646s",
    transform: "translate(-48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#9F9FB1",
    fillRule: "nonzero",
    opacity: 0.6,
    cx: 252.77438,
    cy: 325.297897,
    rx: 155,
    ry: 11.0130391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.760277,56 C239.975994,56.6416701 240.13678,57.312389 240.239723,58 C240.006283,56.951087 239.822843,56.2391304 239.760277,56 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,82 C248,82 248,82.6509434 247,85 L248,82 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.633907,175.866633 C278.829964,174.556541 291.043166,172.792626 309.966487,186.946758 C333.742949,204.72719 298.196103,183.842781 287.604185,190.615872 C277.008697,197.388962 272.066278,188.920458 267.827368,205.857465 C263.59203,222.790191 255.824862,269.071547 264.770497,295.037914 L273.712539,321 L222.86705,321 C222.86705,321 241.229707,262.298457 231.105605,226.176736 C225.43825,205.947374 219.375714,188.905216 214.51422,183.851344 C188.155942,156.450025 190.077448,159.515727 192.005849,159.609917 C193.10218,159.665574 208.036223,166.062349 204.036578,166.062349 C200.033361,166.062349 227.338103,155.055007 232.0484,167.757762 C232.0484,167.757762 250.885743,133.346675 250.182216,144.071449 L250.182216,150.279401 C250.182216,150.279401 280.136991,173.670302 274.633907,175.866633 Z",
    id: "Path",
    fill: "#444053",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,131 C330.27393,138.689264 328.241555,146.11611 325.385468,151.776841 C316.382586,169.62543 276,171 276,171 C276,171 276.190406,168.642403 276.480154,164.922732 C286.733092,164.072998 314.759997,160.444965 322.074063,145.94533 C322.744623,144.620744 323.365511,143.196189 323.953286,141.696657 L332,131 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,153 C269,153 258.712807,141.005638 250.930982,134.464762 C249.222776,133.034204 248.024944,131.008269 247.194018,128.725991 C247.126534,128.544071 247.063267,128.358015 247,128.17196 C247.181365,128.345612 247.36273,128.515129 247.556748,128.676377 C254.368482,134.402744 263.103549,144.309152 265.174463,146.686525 C265.465491,147.025559 265.625767,147.211614 265.625767,147.211614 L263.46204,109 L266.929064,116.450479 L269,153 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.151157,183.95293 L251.151157,190 C251.151157,190 268.074239,174.3326 266.945993,169.110124 C266.083236,165.116169 265.050209,156.943993 259.820397,150 C262.17775,155.247687 262.895251,160.366485 263.522965,163.272411 C264.332028,167.017417 255.859073,176.132893 251,180.991121 C251.170468,181.969084 251.221208,182.96331 251.151157,183.95293 L251.151157,183.95293 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,142 C229.132834,142.282997 229.269812,142.561471 229.414966,142.83079 C233.701733,150.782754 240.164538,159.235586 245,167 C241.091953,159.310811 234.290848,150.518077 229,142 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.191319,131 C239.955281,125.591441 239.586855,119.155738 242.155732,111.614312 C242.123577,108.881247 242.28333,106.149267 242.633843,103.438009 L247,85 C246.195007,87.6589334 244.353176,92.7884636 240.138259,102.343074 C234.802374,114.438855 236.79378,123.89068 242.191319,131 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.869295,167.23444 C207.236002,162.237907 191.539156,134.201864 191.539156,134.201864 L191.109751,134 C195.023063,142.468575 200.698548,157.772404 192.584806,161.339004 C184.992534,164.67639 177.884257,156.373286 174,150.490559 C174.141032,150.906608 174.218464,151.134551 174.218464,151.134551 C174.218464,151.134551 184.502587,172.23097 195.869295,167.23444 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.060224,180 C234.060224,180 237.594627,169.241592 230.954869,162.599167 C232.58308,168.321518 230.67089,174.142744 230.67089,174.142744 C226.350077,164.542404 211.503172,160.389036 205,159 C205.252222,162.196267 205.294872,164.280149 205.294872,164.280149 C205.294872,164.280149 228.474707,167.589591 234.060224,180 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,85 C247.999758,82.6540258 248,82 248,82 L247,85 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,139.979134 C160,139.979134 159.545794,139.987481 158.721495,140 L156.219159,134.145089 C156.492523,134.140916 156.635514,134.136743 156.635514,134.136743 C156.635514,134.136743 154.709346,108.805824 151,97 C151.046262,97.0208657 151.084112,97.0459045 151.126168,97.0667702 C156.946729,99.8168672 160,139.979134 160,139.979134 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.501936,328 C229.687281,308.213672 242.157607,253.499207 232.339552,217.120077 C228.099572,201.409462 224.169529,191.391262 220.847193,185 C223.331751,191.050184 226.048157,199.052956 228.905014,209.638529 C241.073989,254.728613 219,328 219,328 L224.501936,328 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,89 C145.277377,89.3653663 145.613445,89.7014346 146,90 C145.716083,89.6381596 145.380605,89.3026813 145,89 L145,89 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.826833,132.723812 C196.2451,133.122893 196.636996,133.549202 197,134 C195.814603,131.124845 194.350738,128.638683 192.542708,126.925067 C183.612762,118.461073 169,119.007132 169,119.007132 L187.325872,127.481796 C190.466069,128.663778 193.352009,130.443359 195.826833,132.723812 L195.826833,132.723812 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.861939,96.3098001 C215.97468,97.9336266 215.349488,104.824897 214.333694,111.872822 C212.192,126.271352 214.555775,140.98617 221.094749,153.961298 C221.963344,155.697623 222.933477,157.380167 224,159 C217.768554,146.216694 215.550506,131.815325 217.642726,117.723424 C218.65852,110.675538 219.283712,103.784246 218.170971,102.160403 C215.717068,98.579249 205.356047,76.5413403 204.538079,70.7563896 C204.29283,68.5121015 204.235684,66.2508918 204.36725,63.996883 C202.249267,57.9254199 202.046999,47 202.046999,47 C202.046999,47 200.411063,59.1208652 201.229031,64.90577 C202.046999,70.6906747 212.408036,92.7286628 214.861939,96.3098001 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.249447,58 C241.139332,57.31296 240.972105,56.6425683 240.750553,56 C240.750553,56 240.961755,56.7502109 241.249447,58 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.090805,313.570721 C389.025748,319.921996 390.139589,328 390.139589,328 C390.139589,328 397.844152,325.780554 401.909198,319.429279 C405.974243,313.078004 404.860414,305 404.860414,305 C404.860414,305 397.155851,307.219446 393.090805,313.570721 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.98451,314.727887 C395.649415,322.183734 389.893254,328 389.893254,328 C389.893254,328 384.680395,321.727956 385.01549,314.272113 C385.350585,306.81627 391.106746,301 391.106746,301 C391.106746,301 396.319609,307.272044 395.98451,314.727887 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    transform: "translate(337.737415, 261.673331) rotate(-50.158480) translate(-337.737415, -261.673331) ",
    cx: 337.737415,
    cy: 261.673331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    transform: "translate(341.878952, 267.148375) rotate(-50.158480) translate(-341.878952, -267.148375) ",
    cx: 341.878952,
    cy: 267.148375,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.090805,313.570721 C276.025748,319.921996 277.139589,328 277.139589,328 C277.139589,328 284.844152,325.780554 288.909198,319.429279 C292.974243,313.078004 291.860414,305 291.860414,305 C291.860414,305 284.155851,307.219446 280.090805,313.570721 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.98451,314.727887 C282.649415,322.183734 276.893254,328 276.893254,328 C276.893254,328 271.680395,321.727956 272.01549,314.272113 C272.350585,306.81627 278.106746,301 278.106746,301 C278.106746,301 283.319609,307.272044 282.98451,314.727887 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.56948,316.373719 C214.455285,323.553412 220.914522,328 220.914522,328 C220.914522,328 224.31631,320.805979 222.430521,313.626281 C220.544731,306.446584 214.085475,302 214.085475,302 C214.085475,302 210.68369,309.194008 212.56948,316.373719 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.112449,314.687887 C220.359155,319.934594 221,328 221,328 C221,328 213.134257,327.558815 207.887551,322.312113 C202.640845,317.06541 202,309 202,309 C202,309 209.865743,309.441185 215.112449,314.687887 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lady-on-swing",
    transform: "translate(253.000000, 170.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,115 L28.0505304,115 L28.0505304,4.14268771 C28.0518598,3.22802855 27.6657591,2.36171059 27,1.78554782 L27.5999097,1 C28.487302,1.76832067 29.0018583,2.92331447 29,4.14268771 L29,115 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,86.1499132 C40,86.1499132 46.0944128,79.9118259 48.5887205,81.1668109 C51.0830281,82.4217959 41.4168486,88 41.4168486,88 L40,86.1499132 Z",
    id: "Path",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,86.1499132 C40,86.1499132 46.0944128,79.9118259 48.5887205,81.1668109 C51.0830281,82.4217959 41.4168486,88 41.4168486,88 L40,86.1499132 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6618421,74.2496405 C22.6618421,74.2496405 20.5366839,78.0257062 21.0927908,82.0963285 C21.6488978,86.1669509 26.7346702,99.2290606 28.4636444,98.9969455 C30.1926187,98.7648304 43,89.4093838 43,89.4093838 L40.5573314,86.0283789 L31.2011065,91.6479097 C31.2011065,91.6479097 29.7758285,71.5491996 22.6618421,74.2496405 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5202188,82.5272207 L42.4685389,90.8789999 C42.3036542,90.9975464 42.0987244,91.0310154 41.9088501,90.9704079 C41.7189757,90.9098005 41.5636442,90.761337 41.4846203,90.5649355 L38.042375,82.7793672 C37.9075613,82.3206681 38.1033612,81.8242934 38.5027321,81.6123104 L50.1691615,75.1054716 C50.466716,74.9118455 50.8512457,74.9913904 51.0618112,75.2901276 L56.8893317,81.2307341 C57.005264,81.4543308 57.0314004,81.7195834 56.9616427,81.964603 C56.8918851,82.2096225 56.732335,82.4129774 56.5202188,82.5272207 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F94FB",
    points: "56 82.1462827 42.5731365 90 39 83.4101288 50.5183469 77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6618421,74.2496405 C22.6618421,74.2496405 20.5366839,78.0257062 21.0927908,82.0963285 C21.6488978,86.1669509 26.7346702,99.2290606 28.4636444,98.9969455 C30.1926187,98.7648304 43,89.4093838 43,89.4093838 L40.5573314,86.0283789 L31.2011065,91.6479097 C31.2011065,91.6479097 29.7758285,71.5491996 22.6618421,74.2496405 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB9B9",
    cx: 28,
    cy: 61,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6187005,104 C49.6187005,104 56.2075113,104.866946 55.9949661,108.984872 C55.7824209,113.102799 50.8939566,130.224749 50.8939566,130.224749 L50.4688712,136.943483 C50.4688712,136.943483 50.8939566,148.213625 49.6186905,147.996914 C48.3434244,147.780203 45.3678467,139.977778 45.3678467,139.977778 C45.3678467,139.977778 41.7546285,137.593712 43.454965,135.426378 C45.1553015,133.259044 46.4305577,133.475776 46.0054723,131.091705 C45.5803869,128.707635 45.7929321,118.737901 47.0681832,115.703631 C48.3434344,112.669361 49.0865182,110.995821 49.0865182,110.995821 L44.9427613,110.718764 L49.6187005,104 Z",
    id: "Path",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6187005,104 C49.6187005,104 56.2075113,104.866946 55.9949661,108.984872 C55.7824209,113.102799 50.8939566,130.224749 50.8939566,130.224749 L50.4688712,136.943483 C50.4688712,136.943483 50.8939566,148.213625 49.6186905,147.996914 C48.3434244,147.780203 45.3678467,139.977778 45.3678467,139.977778 C45.3678467,139.977778 41.7546285,137.593712 43.454965,135.426378 C45.1553015,133.259044 46.4305577,133.475776 46.0054723,131.091705 C45.5803869,128.707635 45.7929321,118.737901 47.0681832,115.703631 C48.3434344,112.669361 49.0865182,110.995821 49.0865182,110.995821 L44.9427613,110.718764 L49.6187005,104 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6089114,106 C49.6089114,106 56.1931028,107.49719 56.8515209,111.774894 C57.5099391,116.052598 60.8020399,128.671805 60.8020399,128.671805 L64.3136066,136.585549 C64.3136066,136.585549 69.8004328,146.21037 67.3862314,145.996487 C64.9720299,145.782604 61.679929,141.07713 60.5825638,141.07713 C59.4851985,141.07713 56.1931028,139.793823 56.412579,138.938281 C56.6320551,138.082739 58.168388,135.516124 58.168388,135.516124 L52.8585108,126.502167 C51.8332451,124.762142 51.0582917,122.893024 50.5554128,120.947301 C50.0099651,118.836148 49.3894661,116.250081 49.3894661,115.410934 C49.3894661,113.913743 45,113.272085 45,113.272085 L49.6089114,106 Z",
    id: "Path",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6431627,92 L31.7241809,100.745105 C31.7241809,100.745105 36.5657788,102.056868 40.0869381,103.150006 C43.6080975,104.243143 50.2102802,102.712749 50.8704969,105.336281 C51.5307136,107.959812 49.5500635,112.550992 47.5694081,113.64413 C45.5887528,114.737267 44.4883899,115.830405 38.1062828,114.081386 C31.7241758,112.332367 16.5391653,111.895111 16.5391653,111.895111 C15.0671405,112.77252 13.4093106,113.296546 11.6975674,113.425499 C8.83661966,113.64413 8.17640294,113.862755 7.29611569,113.206874 C6.41582844,112.550992 7.73625673,112.550992 8.17641841,110.801968 C8.61658008,109.052944 8.83663513,109.70883 10.8172905,107.741186 C12.7979458,105.773542 14.3384549,99.870593 15.4388179,97.9029435 C16.5391808,95.935294 17.1994233,92 17.1994233,92 L28.6431627,92 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,66.237839 C26.4221564,67.3817825 25.4714856,69.1898871 25.4285707,71.1285045 C25.4285707,74.3180696 19,67.7263037 19,67.7263037 C19,67.7263037 22.4285741,63.4735502 22.4285741,62.1977212 C22.4285741,60.9218922 28,66.237839 28,66.237839 Z",
    id: "Path",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.178604,64 C20.178604,64 23.9494786,65.5206701 24.7874529,67.6930618 C25.6254273,69.8654535 28.7678187,74.4274791 28.7678187,74.4274791 C28.7678187,74.4274791 33.1671766,79.2067419 31.700724,84.420484 C30.2342713,89.6342261 28.9773148,90.9376591 28.9773148,91.8066178 C28.9773148,92.6755766 26.8823838,94.1962467 25.2064401,93.9790095 C23.5304964,93.7617724 17.2456987,92.8928137 16.8267116,92.023855 C16.4077244,91.1548963 13.8938112,78.7722625 15.569755,74.2102471 C16.9293065,70.7240176 18.4677891,67.3157289 20.178604,64 L20.178604,64 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7456288,61.5483189 C31.1813193,61.8873471 32.5902234,60.9772008 33.7666198,60.0748277 C34.4346249,59.5624245 35.1698162,58.8317191 34.9651419,58.0070378 C34.7835681,57.2754297 33.9173481,56.860742 33.7912806,56.1171825 C33.703669,55.6004981 34.0072148,55.097818 34.0318238,54.5741185 C33.9874122,53.7604777 33.4906,53.0394253 32.7438756,52.7048442 C32.0443821,52.330065 31.2510509,52.1738151 30.5324591,51.8384182 C29.4351206,51.3262162 28.5231352,50.4029527 27.3511765,50.1072011 C25.7501125,49.7031547 24.1198516,50.5634272 22.4737946,50.6747963 C21.4776502,50.7421924 20.4687839,50.5331954 19.4833447,50.6957899 C17.5488554,51.0849966 16.134726,52.7429412 16.06338,54.7054032 C16.0506841,55.4059748 16.1913863,56.1875858 15.7712444,56.7431935 C15.6051976,56.9345565 15.416127,57.1048737 15.2082903,57.2503096 C13.7444397,58.4281679 13.0798198,60.3959985 13.004256,62.2917959 C12.9670652,63.2248701 13.1634967,64.3332949 13.9954963,64.7299187 C14.4411668,64.8816815 14.9120074,64.9467687 15.3823783,64.921636 C15.86223,64.9015691 16.3208805,65.119447 16.6068988,65.5033335 C16.9858581,66.1685307 16.4180672,67.1510404 16.9137988,67.7315463 C17.2861742,68.1675886 18.0124955,68.022769 18.4473707,67.651224 C18.8822459,67.2796789 19.153448,66.7453279 19.5656789,66.3480335 C20.3675847,65.5752068 21.5570761,65.4351172 22.6562239,65.3176306 C22.9819419,65.315139 23.2987916,65.2117599 23.5627452,65.0218584 C23.7624562,64.8133268 23.8923421,64.5483615 23.9345452,64.2633919 C24.0793004,63.6075663 24.0811688,62.9284951 23.9400248,62.2718907 C23.8702913,62.0686169 23.8614924,61.8495494 23.9147004,61.641387 C23.9873519,61.4934449 24.0996303,61.3683231 24.2391693,61.2798023 C24.9204199,60.7706281 26.1138512,60.029266 26.9991954,60.1695 C27.9816693,60.3251001 28.7545855,61.3142947 29.7456288,61.5483189 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6526274,73.1038496 C20.6526274,73.1038496 18,76.5084576 18,80.5514032 C18,84.5943487 21.3157895,98 23.0842095,98 C24.8526295,98 39,90.5524464 39,90.5524464 L37.0105294,86.9350526 L26.8421053,91.1908089 C26.8421053,91.1908089 28.168419,71.4015481 20.6526274,73.1038496 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF6584",
    x: 0,
    y: 111,
    width: 50,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6779383,123 C23.6476311,122.997424 22.0023207,121.170917 22,118.917014 L22,4.08302788 C22,2.50721211 22.8168842,1.07206664 24.098887,0.395509555 C25.3808899,-0.281047532 26.8991642,-0.0782361124 28,0.916621066 L27.4190329,1.70809773 C26.5934331,0.962031268 25.4547863,0.809990494 24.4933695,1.31744093 C23.5319527,1.82489136 22.9194082,2.90123761 22.9194846,4.08302788 L22.9194846,118.917014 C22.9211467,120.607477 24.1551754,121.977408 25.6779383,121.979253 L25.6779383,123 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6C63FF",
    transform: "translate(16.671310, 57.179777) rotate(-38.768250) translate(-16.671310, -57.179777) ",
    cx: 16.6713099,
    cy: 57.1797774,
    rx: 1,
    ry: 1.51813232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,88.0205029 C36,88.0205029 42.5138717,82.7418475 44.6851623,84.2814557 C46.8564529,85.821064 37.0856656,90 37.0856656,90 L36,88.0205029 Z",
    id: "Path",
    fill: "#FFB9B9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(79.000000, 40.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 185,
    cy: 57,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6C63FF",
    cx: 163,
    cy: 57,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6C63FF",
    cx: 118,
    cy: 58,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F94FB",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#000000",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6C63FF",
    cx: 63,
    cy: 72,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 107,
    cy: 36,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 55,
    cy: 57,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    cx: 163,
    cy: 57,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    cx: 118,
    cy: 58,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 55,
    cy: 107,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 98,
    cy: 97,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 146,
    cy: 98,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 161,
    cy: 107,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 187,
    cy: 110,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 197,
    cy: 82,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 185,
    cy: 66,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 163,
    cy: 49,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 150,
    cy: 51,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 118,
    cy: 50,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 40,
    cy: 82,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    cx: 108,
    cy: 66,
    rx: 40,
    ry: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,72.2694244 C33,72.2694244 70.3812328,57.0805662 93,84",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,39.0043116 C114,39.0043116 155.793651,37.8787346 164,72",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,96.2741999 C165,96.2741999 202.381233,81.0750859 225,108",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.f8399f6d246dd75786b4bff28586df82.svg";
export { ForwardRef as ReactComponent };